var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHamburger = function SvgHamburger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 19 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#16342E",
    d: "M.54.535h17.92v1.991H.54zm0 6.97h11.947v1.991H.539zm0 6.97h17.92v1.99H.54z"
  })));
};
export default SvgHamburger;